import api from './api';

export interface SiteContent {
  key: string;
  title: string;
  content: string;
  updated_at: string;
}

export const contentService = {
  // Get content by key (e.g., 'terms')
  get: async (key: string): Promise<SiteContent> => {
    const response = await api.get(`site/content/${key}/`);
    return response.data;
  },

  // Update content (admin only)
  update: async (key: string, data: { title: string; content: string }) => {
    // Try to update first
    try {
      const response = await api.patch(`site/content/${key}/`, data);
      return response.data;
    } catch (error: any) {
      // If 404, create it
      if (error.response && error.response.status === 404) {
        const response = await api.post('site/content/', { key, ...data });
        return response.data;
      }
      throw error;
    }
  },
};
